import React, {Component} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {searchTaxGroups} from './actions';
import {Link} from "react-router-dom";
import ListView from "../common/ListView";

class TaxGroupsPage extends Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    salonId: PropTypes.string.isRequired,
    search: PropTypes.object.isRequired,
    searchTaxGroups: PropTypes.func.isRequired,
  };

  render() {
    const {
      salonId, history, searchTaxGroups, search: {searching, pagination, filters, sorter, results, searchFilter},
    } = this.props;
    const columns = [
      {
        title: 'Name',
        dataIndex: 'name',
        key: 'name',
        sorter: true,
      },
      {
        title: 'Taxes',
        dataIndex: 'taxes',
        key: 'taxes',
        render: taxes => taxes.map(({name}) => (name)).join(', ')
      },
      {
        title: 'Action',
        key: 'action',
        render: (_, {taxGroupId}) => {
          const encodedId = encodeURIComponent(taxGroupId);
          return (
            <React.Fragment>
              <Link to={`/tax/update-group/${encodedId}`}>Edit</Link>
              {` | `}
              <Link to={`/tax/add-to-group/${encodedId}`}>Add Tax</Link>
              {` | `}
              <Link to={`/tax/remove-from-group/${encodedId}`}>Remove Tax</Link>
            </React.Fragment>
          );
        }
      }
    ];
    return (
      <ListView
        title="Tax Groups"
        loading={searching}
        columns={columns}
        dataSourceProvider={searchTaxGroups}
        dataSource={results}
        pagination={pagination}
        filters={filters}
        sorter={sorter}
        searchFilter={searchFilter}
        salonId={salonId}
        rowKey="taxGroupId"
        onAdd={() => history.push('/tax/add-group')}
      />
    );
  }
}

const mapStateToProps = state => ({
  salonId: state.salon.selectedSalonId,
  search: state.tax.searchTaxGroups,
});

const mapDispatchToProps = dispatch => ({
  searchTaxGroups: payload => (dispatch(searchTaxGroups(payload))),
});

export default connect(mapStateToProps, mapDispatchToProps)(TaxGroupsPage);



// WEBPACK FOOTER //
// ./src/Tax/TaxGroupsPage.js